import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { ICreateNoticeErrorState, ICreateNoticeMainState } from '../CreateNoticeDialog';
import { onConfirmCreateNotice } from '../../../../../redux/project/documents/sliceProjectDocumentsCreateNotice';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({
    mainState,
    showErrorState,
    setShowErrorState,
    onClose,
}: ICreateNoticeDialogActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'createNoticeDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();

    const params = useParams();

    const { replicaId } = params;

    const isLoading = useSelector(
        (_store: IAppReduxStore) => _store.projectDocumentsCreateNotice.loading,
    );

    const { data: documents } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocuments.info,
    );

    const validateInput = () => {
        const isValidDate =
            !mainState.dueDate ||
            (!mainState.dueDateErrorContext?.validationError &&
                mainState.dueDate.endOf('day').isAfter(dayjs().startOf('day')));

        setShowErrorState({
            taskType: mainState.taskType === '',
            dueDate: !isValidDate,
            assignees: mainState.assignees.length === 0,
            approvalMethod: mainState.approvalMethod === null,
        });
        return (
            mainState.taskType !== '' &&
            isValidDate &&
            mainState.assignees.length !== 0 &&
            mainState.approvalMethod !== null
        );
    };
    const onCreateNotice = () => {
        if (validateInput()) {
            dispatch(onConfirmCreateNotice({ replicaId, ...mainState }));
        }
    };
    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button
                variant={'text'}
                onClick={onClose}
                sx={{ ...buttonSx, color: vars.font }}
                disabled={isLoading}
            >
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={onCreateNotice}
                sx={buttonSx}
                disabled={
                    !documents?.length ||
                    isLoading ||
                    Object.values(showErrorState).some(errorValue => errorValue === true)
                }
            >
                {t('ctaCreate')}
            </Button>
        </DialogActions>
    );
};

interface ICreateNoticeDialogActionsProps {
    mainState: ICreateNoticeMainState;
    showErrorState: ICreateNoticeErrorState;
    setShowErrorState: Dispatch<React.SetStateAction<ICreateNoticeErrorState>>;
    onClose: () => void;
}
